module.exports = __webpack_public_path__ + "static/img/logo-login.16b987d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-login.png
// module id = 109
// module chunks = 4